import React from 'react';

const MinusCircle = () => {
    return (
        <svg width={10} height={10} viewBox="0 0 10 10">
            <path
                d="M5 0a5 5 0 105 5 5 5 0 00-5-5zm0 9a4 4 0 114-4 4 4 0 01-4 4zm2-4.5H3a.5.5 0 000 1h4a.5.5 0 000-1z"
                fill="#000946"
            />
        </svg>
    );
};

export default MinusCircle;
